import { ChevronRight } from "lucide-react";
import { groupByPhase, phaseLabel, phaseTone } from "./dprUtils";

export function StepProcess({ processes, todayCount, onPick }) {
  const groups = groupByPhase(processes);
  return (
    <div className="space-y-6" data-testid="wiz-step-process">
      <div>
        <h3 className="font-heading text-lg font-semibold text-slate-900">Which machine did you run?</h3>
        <p className="text-sm text-slate-500 mt-0.5">Tap the process. Stages are listed in production order.</p>
      </div>
      {groups.map((g, gi) => {
        const tone = phaseTone(g.phase);
        return (
          <div key={g.phase} data-testid={`wiz-phase-group-${g.phase}`}>
            <div className="flex items-center gap-2 mb-2">
              <span className={`w-2 h-2 rounded-full ${tone.bar}`} />
              <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Step {gi + 1} · {phaseLabel(g.phase)}</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
              {g.procs.map((p) => {
                const n = todayCount[p.id] || 0;
                return (
                  <button key={p.id} data-testid={`wiz-process-${p.id}`} onClick={() => onPick(p)}
                    className={`group text-left bg-white border-2 border-slate-200 ${tone.hover} hover:ring-4 rounded-xl px-4 py-3.5 transition-[border-color,box-shadow,transform] active:scale-[0.99] flex items-center gap-3`}>
                    <span className={`w-1 self-stretch rounded-full ${tone.bar} opacity-70 group-hover:opacity-100`} />
                    <span className="flex-1 min-w-0">
                      <span className="block font-semibold text-slate-800 leading-tight">{p.name}</span>
                      <span className="block text-xs text-slate-400 mt-0.5">
                        {n > 0 ? <span className="text-emerald-600 font-medium">{n} saved today</span> : "no entry today"}
                        {p.multiplier && p.multiplier !== 1 ? <span className="ml-1.5 text-slate-400">· ×{p.multiplier} output</span> : null}
                      </span>
                    </span>
                    <ChevronRight size={18} className="text-slate-300 group-hover:text-slate-500 shrink-0" />
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
